module.exports = __webpack_public_path__ + "5601411a9ccefe29285ef4aa2eaaf5ad.MP3";